module.exports = __webpack_public_path__ + "assets/img/87928627ffb132095ab78cf55030fdcf.svg";